var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { Tooltip } from '../';
import useKeyboardEscapeHandler from '../hooks/useKeybordEscapeHandler';

var useStyles = makeStyles(function (theme) {
  return {
    title: _extends({
      padding: 0
    }, R.pathOr({}, ['mixins', 'share', 'title'], theme)),
    label: theme.typography.body2,
    icon: {
      marginLeft: theme.spacing(0.5)
    },
    radioGroup: {
      alignContent: 'flex-start'
    }
  };
});

var Warning = function Warning(_ref) {
  var title = _ref.title,
      children = _ref.children;

  var classes = useStyles();

  var _useKeyboardEscapeHan = useKeyboardEscapeHandler(),
      open = _useKeyboardEscapeHan.open,
      setOpen = _useKeyboardEscapeHan.setOpen;

  return React.createElement(
    Tooltip,
    {
      className: classes.icon,
      title: title,
      variant: 'light',
      'aria-label': title,
      'aria-hidden': false,
      open: open,
      onOpen: function onOpen() {
        return setOpen(true);
      },
      onClose: function onClose() {
        return setOpen(false);
      }
    },
    children
  );
};

Warning.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  children: PropTypes.node
} : {};

var Mode = function Mode(_ref2) {
  var changeMode = _ref2.changeMode,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === undefined ? 'end' : _ref2$placement,
      mode = _ref2.mode,
      _ref2$modes = _ref2.modes,
      modes = _ref2$modes === undefined ? [] : _ref2$modes,
      _ref2$isSmall = _ref2.isSmall,
      isSmall = _ref2$isSmall === undefined ? false : _ref2$isSmall,
      children = _ref2.children;

  var classes = useStyles();
  var mapIndexed = R.addIndex(R.map);
  return React.createElement(
    RadioGroup,
    {
      onChange: function onChange(e) {
        return changeMode(e.target.value);
      },
      value: mode,
      className: classes.radioGroup,
      tabIndex: 0
    },
    mapIndexed(function (_ref3, idx) {
      var label = _ref3.label,
          value = _ref3.value,
          popperLabel = _ref3.popperLabel,
          disabled = _ref3.disabled;
      return React.createElement(FormControlLabel, {
        classes: { label: classes.label },
        key: value + '-' + idx,
        checked: mode === value,
        control: React.createElement(Radio, {
          variant: 'outlined',
          color: 'primary',
          size: isSmall ? 'small' : 'medium',
          inputProps: { tabIndex: '0', id: label + '_' + idx }
        }),
        label: React.createElement(
          'span',
          { id: label },
          label,
          popperLabel && React.createElement(
            Warning,
            { title: popperLabel },
            children
          )
        ),
        labelPlacement: placement,
        value: value,
        disabled: disabled || false,
        style: { height: isSmall ? '25px' : null },
        role: 'radio'
      });
    })(modes)
  );
};

Mode.propTypes = process.env.NODE_ENV !== "production" ? {
  changeMode: PropTypes.func,
  children: PropTypes.node,
  mode: PropTypes.string,
  placement: PropTypes.string,
  modes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    value: PropTypes.string,
    popperLabel: PropTypes.string,
    disabled: PropTypes.bool
  })),
  isSmall: PropTypes.bool
} : {};

export default Mode;